'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _chart = require('chart.js');

var _chart2 = _interopRequireDefault(_chart);

var _scales = require('./scales');

var _defaultOptions = require('./defaultOptions');

var _defaultOptions2 = _interopRequireDefault(_defaultOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RWIChart = function (_React$Component) {
  _inherits(RWIChart, _React$Component);

  function RWIChart(props) {
    _classCallCheck(this, RWIChart);

    var _this = _possibleConstructorReturn(this, (RWIChart.__proto__ || Object.getPrototypeOf(RWIChart)).call(this, props));

    _this.pieLegend = _this._pieLegend.bind(_this);

    return _this;
  }

  _createClass(RWIChart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.createCanvas();
      this.renderChart();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {

      if (!this.chart) {
        this.createCanvas();
        this.renderChart();
        return;
      }

      if (prevProps.data !== this.props.data) {
        var data = this.addColors.bind(this)(this.props.data);
        this.chart.data.datasets = data.datasets;
        this.chart.data.labels = data.labels;
        // this.chart.options = overrideDefaultOptions(this.chart.options, this.props.type, this.props.data);
        this.chart.update();
      }
    }
  }, {
    key: 'createCanvas',
    value: function createCanvas() {
      var type = this.props.type;

      var canvas = document.createElement('CANVAS');

      switch (type) {

        case 'pie':
          // canvas.style.width = '200px';
          // canvas.style.height = '200px';
          break;

        default:
          canvas.style.width = '400px';
          canvas.style.height = '200px';
          break;

      }

      this.element.appendChild(canvas);
      this.ctx = canvas.getContext('2d');
    }
  }, {
    key: 'renderChart',
    value: function renderChart() {

      var data = this.addColors.bind(this)(this.props.data);
      var options = this.overrideDefaultOptions(_defaultOptions2.default[this.props.type], this.props.type, data);

      this.chart = new Chart(this.ctx, {
        type: this.props.type,
        data: data,
        options: options
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var type = this.props.type;

      if (this.chart) this.chart.update();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', {
          className: (0, _classnames2.default)("chart", "chart-" + type),
          ref: function ref(element) {
            return _this2.element = element;
          } }),
        this.pieLegend()
      );
    }
  }, {
    key: 'addColors',
    value: function addColors(data) {
      var this$1 = this;


      if (!data.datasets) return data;

      for (var i = 0; i < data.datasets.length; i++) {
        data.datasets[i].backgroundColor = this$1.getColors(data.datasets[i].data.length);
        data.datasets[i].borderWidth = 0;
        data.datasets[i].fill = false;
        data.datasets[i].borderColor = (0, _scales.colorScale)(i);
        data.datasets[i].pointBackgroundColor = (0, _scales.colorScale)(i);
        data.datasets[i].pointBorderColor = (0, _scales.colorScale)(i);
      }
      return data;
    }
  }, {
    key: 'getColors',
    value: function getColors(itemCount) {

      var colors = [];
      for (var i = 0; i < itemCount; i++) {
        colors.push((0, _scales.colorScale)(i));
      }
      return colors;
    }
  }, {
    key: '_pieLegend',
    value: function _pieLegend() {

      if (this.props.type !== 'pie') return;

      return _react2.default.createElement(
        'div',
        { className: 'pie-legend' },
        this.props.data.labels.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            { className: 'item', key: item },
            _react2.default.createElement('div', { className: 'color', style: { backgroundColor: (0, _scales.colorScale)(i) } }),
            item
          );
        })
      );
    }
  }, {
    key: 'overrideDefaultOptions',
    value: function overrideDefaultOptions(options, type, data) {

      var key = data.datasets[0].label;

      if (['line', 'bar'].indexOf(type) !== -1) {
        try {
          options.scales.xAxes[0].ticks.autoSkip = false;
        } catch (e) {
          console.warn('xAxes scales not found');
        }
        switch (key) {
          case 'doors':
          case 'units':
            options.scales.yAxes[0].ticks.callback = function (value) {
              return new Intl.NumberFormat().format(value);
            };
            break;
        }
        if (data.datasets.length < 2) {
          if (!options.legend) {
            options.legend = { display: false };
          } else {
            options.legend.display = false;
          }
        }
      }

      if (type == 'radar') {
        switch (key) {
          case 'doors':
          case 'units':
            options.scale.ticks.callback = function (value) {
              return new Intl.NumberFormat().format(value);
            };
            break;
        }
        if (data.datasets.length < 2) {
          if (!options.legend) {
            options.legend = { display: false };
          } else {
            options.legend.display = false;
          }
        }
      }

      return options;
    }
  }]);

  return RWIChart;
}(_react2.default.Component);

exports.default = RWIChart;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/charts/Chart.js
// module id = 242
// module chunks = 0